import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import Close from "shared/assets/images/svg/close_dialog.svg";
import Input from "shared/component/inputFields";
import TextArea from "shared/component/textArea";
import { AddressTypes, useAddress } from "customer/settings/address/address.service";
import { localize } from "shared/helpers/utils";
import { LocationField } from "shared/component/dxf-map/dxf-map";
import useModal from "shared/hooks/useModel";

const NewAddress = ({ show, onHide, addressType,onSubmit,serverErrors ={} }) => {
  const [isChoosingLocation,openLocationField,closeLocationField] = useModal(false);
  const { addressForm, activeCities, addAddressServer } = useAddress(addressType);
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    watch
  } = addressForm;
  const isCustomerAddress = addressType === AddressTypes.Customer;

  React.useEffect(() => {
    return () => reset({});
  }, [reset]);

  const location = watch('location');
  const locationValue = location?.lat + " - " + location?.lng;

  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={onHide}
      className="all-modal newAddress"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Body>
        <div className="header">
          <h1>{isCustomerAddress ? "New Customer" : "New Address"}</h1>
          <img src={Close} alt="back" onClick={onHide} />
        </div>
        <hr className="hr" />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="div-req">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">
                {isCustomerAddress ? "Customer Name" : "Address Name"}{" "}
                <small className="star-require">*</small>
              </label>
              <div className="col-sm-9">
                <Input type="text" {...register("name")} error={errors.name?.message ?? serverErrors['AddressName']} />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">
                City <small className="star-require">*</small>
              </label>
              <div className="col-sm-9">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <Input
                      type="select"
                      options={activeCities}
                      {...register("cityId")}
                      error={errors.cityId?.message ?? serverErrors['CityId']}
                      getOptionLabel={(c) => localize(c.name)}
                    />
                  </div>
                  <label className="col-md-2 col-form-label">Location</label>
                  <div className="col-md-6 col-sm-12">
                    <Input type="text" value={locationValue} location onLocationIconClick={openLocationField}  />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-prim">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Contact Person </label>
              <div className="col-sm-9">
                <Input type="text" {...register("contactPerson")} />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Phone </label>
              <div className="col-sm-9">
                <Input type="phone" control={control} name="phone" />
              </div>
            </div>
          </div>
          <div className="div-prim">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Neighborhood </label>
              <div className="col-sm-9">
                <Input type="text" {...register("neighborhood")} />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Street </label>
              <div className="col-sm-9">
                <Input type="text" {...register("street")} />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Building Number</label>
              <div className="col-sm-9">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <Input type="text" {...register("buildingNumber")} />
                  </div>
                  <label className="col-md-4 col-form-label">Apartment Number</label>
                  <div className="col-md-4 col-sm-12">
                    <Input type="text" {...register("apartmentNumber")} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row pl-24">
            <label className="col-sm-3 col-form-label">Full Address</label>
            <div className="col-sm-9">
              <TextArea {...register("fullAddress")} />
            </div>
          </div>
          <div className="form-group row pl-24">
            <div className="col-sm-3"></div>
            <div className="col-sm-9 ">
              <div className="row">
                <div className="col-sm-5">
                  <button
                    disabled={addAddressServer.isLoading}
                    type="submit"
                    className="btn-blue w-100"
                  >
                    <Spinner animation="border" size="sm" hidden={!addAddressServer.isLoading} />
                    Save
                  </button>
                </div>
                <div className="col-sm-5">
                  <button type="button" onClick={onHide} className="btn-border-blue w-100">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <LocationField show={isChoosingLocation} onHide={closeLocationField} onChoose={l => setValue('location', {lat: l.lat,lng:l.lng})} />
    </Modal>
  );
};

export default NewAddress;
